import React, { useEffect } from "react"
import MScienceCarousel from "../blocks/m_science_carousel"
import MHeroCollectionSlider from "../blocks/m_hero_collection_slider"
import MHighlightCarousel from "../blocks/m_highlight_carousel"
import DfbSpinner from "../ui-kit/dfb_spinner"

import useRemoteCollectionHandler from "../../hooks/useRemoteCollectionHandler"

const MMultiFormatSliderRemote = (props) => {
  const { uid } = props.data
  const { collectionForPage, totalCount } = useRemoteCollectionHandler(
    props.data
  )

  useEffect(() => {
    if (collectionForPage && window.upgradeAllBehaviours) {
      // ensure grid and images are initialized by ui kit
      window.upgradeAllBehaviours()
    }
  }, [collectionForPage])

  let dataCopy = {
    ...props.data,
  }
  dataCopy.collection = collectionForPage
  //dataCopy.find_item_image = false

  const componentProps = {
    ...props,
    data: dataCopy,
  }

  if (totalCount === null) {
    return (
      <section className="m-Error">
        <div className="m-Error-wrapper">
          <div className="m-Error-container">
            <div className="m-Error-content">
              <DfbSpinner type="continuous" autoLoop={true} />
              <br />
              <br />
              <br />
              <p className="m-Error-text">Daten werden geladen …</p>
            </div>
          </div>
        </div>
      </section>
    )
  }

  // empty result state: totalCount is zero
  if (totalCount === 0) {
    return (
      <section
        className="m-Empty"
        data-info={`MultiFormatSlider: empty remote collection in component ${uid}`}
      ></section>
    )
  }

  // error result state: totalCount is undefined
  if (totalCount === undefined) {
    return (
      <section
        className="m-Empty"
        data-info={`MultiFormatSlider: remote collection request failed in component ${uid}`}
      ></section>
    )
  }

  switch (props.data.slider_type) {
    case "hero-slider":
      return MHeroCollectionSlider(componentProps)
    case "highlight-carousel":
      return <MHighlightCarousel {...componentProps} />
    case "carousel":
    default:
      return MScienceCarousel(componentProps)
  }
}

export default MMultiFormatSliderRemote
